import { HOME_LAT, HOME_LNG, homeLocation, statusMap } from "../popData";
import { dateTimeFormatter } from "./dateFormatters";
import * as tt from "@tomtom-international/web-sdk-maps";
import * as ttapi from "@tomtom-international/web-sdk-services";

export function setupPopUpHtml(data) {
  //   console.log("data", data);
  return `<div
    class="tt-popup"
  >
      <div class="tt-popup-summary">
        <div class="tt-popup-header">
          <div class="tt-popup-name">
            <p>${data?.authorisedBy || data?.refNumber || "0-0"}</p>
          </div>
        </div>
        <div class="tt-popup-footer">
          <div class="tt-popup-status">
            <p>${
              statusMap[data?.status || "home-status"]?.name ||
              "selected" ||
              "--"
            }</p>
            <p>${dateTimeFormatter(data?.bookedInDateTime, "dt_medium")}</p>
          </div>
          <div class="tt-popup-address">
            <p>${data?.address || ""}</p>
            <p>${data?.address2 || ""}</p>
            <p>${data?.postcode || ""}</p>
          </div>
        </div>
      </div>
    
  </div>`;
}

export function getInvalidAddressQueries(primaries, addressQueries) {
  const badQueries = addressQueries.filter((aQ) => !aQ?.query);
  const invalidAddresses = badQueries.map((query) => {
    return primaries.find((primary) => query.trackingId === primary.uid);
  });

  return invalidAddresses;
}

export function formatAddressQueries(primaries) {
  // Takes in primaries and returns them as an array of queries which
  // can be used by the tom_tom_api to find the lat, lon of address

  let addressQueries = primaries.map((sheet) => {
    let formattedAddress = formatAddressQuery(sheet);

    return {
      query: formattedAddress,
      bestResult: true,
      radius: 100000,
      // trackingId allows us to later link this query to response from tomtom geocode api
      trackingId: sheet.uid,
    };
  });

  return addressQueries;
}

function formatAddressQuery(sheet) {
  let address = sheet?.address || "";
  let postcode = sheet?.postcode || "";
  // let city = sheet?.city || "";
  let flat = sheet?.flat || "";
  let formattedAddress = `${flat} ${address} ${postcode} ${sheet.city}`;

  if (!address && !postcode) return null;

  return formattedAddress;
}

export function markerClick(e, location, popup, marker, setRoutes) {
  e.preventDefault();

  if (popup.isOpen()) {
    // Have to add this to prevent pop up from closing once you click
    // on the marker.
    marker.togglePopup();
  }
  setRoutes(location);

  //   if (e.shiftKey) {
  //     if (!popup.isOpen()) {
  //       marker.togglePopup();
  //     }

  //     setRoutes(location);
  //   } else {
  //     // logic to show who it is.
  //   }
}

export function attachMarkers(locations, setRoutes) {
  const locationsWithMarkers = locations.map((location) => {
    let isHome = location?.uid === "home";

    const popupOffset = {
      bottom: [0, -24],
    };

    const popup = new tt.Popup({
      offset: popupOffset,
      className: "popup-container",
    }).setHTML(setupPopUpHtml(location));

    const markerElement = document.createElement("div");
    markerElement.className = isHome ? "home-marker" : `tt-marker`;
    markerElement.style.background =
      statusMap[location?.status ?? "no-status"]?.background;
    markerElement.id = `${location.uid}`;

    const marker = new tt.Marker({
      element: markerElement,
      draggable: false,
    })
      .setLngLat([location.position.lng, location.position.lat])
      .setPopup(popup);
    //   .addTo(map);

    markerElement.addEventListener("click", (e) =>
      markerClick(e, location, popup, marker, setRoutes)
    );

    markerElement.addEventListener("mouseenter", (e) => {
      marker.togglePopup();
      //   }
    });
    markerElement.addEventListener("mouseleave", (e) => {
      marker.togglePopup();
    });

    return {
      ...location,
      marker,
    };
  });

  return locationsWithMarkers;

  // setMarkers((prevState) => {
  //   return [...prevState, { uid: location.uid, marker: marker }];
  // });
  //   });
}

export async function geoCodeAddresses(
  primaries,
  addressQueries,
  setLocationData,
  setRoutes,
  tomtomKey
) {
  // Use tomtom api to find lon lat coordinates of primaries

  // Only use valid address queries
  const validAddressQueries = addressQueries.filter((aQ) => aQ?.query);

  function callbackFn(result) {
    // Result contains batch where each item contains primary along with the geo location of its address.
    // This function formats that response into more useful data structure (mapLocations) and sets it as state.
    let mapLocations = [homeLocation];

    // loop through the batch items and match each item to the query passed in (via the tracking id we applied earlier)
    result.batchItems.forEach((item, i) => {
      let result = item?.results[0];
      let trackingId = validAddressQueries[i].trackingId;

      // Match batch item to its associated query
      let primary = primaries.find((p) => {
        return p?.uid === trackingId;
      });

      // Update primary with its associated lng and lat position
      if (primary && result?.position) {
        let updatedPrimary = { ...primary, position: result?.position };
        mapLocations.push(updatedPrimary);
      }
    });

    const locationsWithMarkers = attachMarkers(mapLocations, setRoutes);

    // const locationData = setupLocationData(locationsWithMarkers);

    // Update state: contains primaries and their associated map lat lon positions.
    setLocationData(locationsWithMarkers);
  }

  if (validAddressQueries.length > 0) {
    ttapi.services
      .geocode({
        key: tomtomKey,
        // bestResult: true,
        center: [HOME_LNG, HOME_LAT],
        radius: 100000,
        batchItems: validAddressQueries,
        batchMode: "sync",
      })
      .then(callbackFn)
      .catch((err, i) => {
        console.log("Error in geocode", err, i);
      });
  }
}

export function getPrimariesMetadata(primaries) {
  let data = {};
  primaries.forEach(
    (primary) => {
      let { status } = primary;

      if (data[status]) {
        data[status].push(primary);
      } else {
        data[status] = [primary];
      }
    },
    [primaries]
  );

  return data;
}
